import { defineStore } from "pinia";

const LOADING_SETTLE_DELAY = 250;
let settleTimer = null;

export const useLoadingStore = defineStore("loading", {
  state: () => ({
    activeRequests: 0, // 目前進行中的 API 請求數量
    isRouteNavigating: false, // 是否正在切換路由
    isSettling: false, // 等待短時間內可能接續啟動的請求
  }),
  getters: {
    isLoading: (state) =>
      state.activeRequests > 0 || state.isRouteNavigating || state.isSettling,
  },
  actions: {
    show() {
      if (settleTimer) {
        clearTimeout(settleTimer);
        settleTimer = null;
      }
      this.isSettling = false;
      this.activeRequests++;
    },
    hide() {
      if (this.activeRequests > 0) {
        this.activeRequests--;
      }

      if (this.activeRequests !== 0) return;

      // 首頁權限與各區塊 API 會分批啟動，避免 loading 短暫消失後又出現，
      // 造成使用者在間隙點擊時，點擊事件被新的遮罩層擋下。
      this.isSettling = true;
      if (settleTimer) clearTimeout(settleTimer);
      settleTimer = setTimeout(() => {
        this.isSettling = false;
        settleTimer = null;
      }, LOADING_SETTLE_DELAY);
    },
    startRouteNavigation() {
      this.isRouteNavigating = true;
    },
    finishRouteNavigation() {
      this.isRouteNavigating = false;
    },
    reset() {
      if (settleTimer) {
        clearTimeout(settleTimer);
        settleTimer = null;
      }
      this.activeRequests = 0;
      this.isRouteNavigating = false;
      this.isSettling = false;
    },
  },
});
